import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Container } from 'components/core/Page';
import {SectionHeader, IconContentList} from 'components/molecules';
import IconContentItem from 'components/molecules/IconContentItem/IconContentItem'; 
import './IconContentBlock.scss';
export function ContentIconBlock({
    className,
    headerContent,
    itemsContent,
}) {
    return (
        <section className={classnames('content-icon-block-section', className)}>
            <Container className="content-icon-block-container">
                <SectionHeader 
                    {...headerContent}
                />
                <IconContentList 
                    {...itemsContent} 
                    ItemComponent={IconContentItem}
                />
            </Container>
        </section>
    )
}

ContentIconBlock.propTypes = {
    className: PropTypes.string,
    headerContent: PropTypes.shape({
        className: PropTypes.string,
        image: PropTypes.string,
        prefix: PropTypes.string,
        prefixProps: PropTypes.object,
        title: PropTypes.string,
        titleProps: PropTypes.object,
        suffix: PropTypes.string,
        suffixProps: PropTypes.object,
        description: PropTypes.string,
        contentAlign: PropTypes.oneOf(['text-left', 'text-center']),
        additionalProps: PropTypes.object,
    }),
    itemsContent: PropTypes.shape({
        className: PropTypes.string,
        columns: PropTypes.number,
        rowGap: PropTypes.string,
        colGap: PropTypes.string,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                title: PropTypes.string.isRequired,
                description: PropTypes.string,
                icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
                alt: PropTypes.string,
            })
        ),
    }),
};

export default ContentIconBlock;